import { ref, watch, onMounted } from 'vue';
import { useUserStore } from '@/stores/UserStore';
import useSettingsGlobals from '@/composables/useSettingsGlobals'

const { $PLATFORM } = useSettingsGlobals()  

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const storageSystem = ref(null);

export default (initialValue, key, system = 'localStorage') => {
  if (system === 'off') return;

  storageSystem.value = system;
  const userStore = useUserStore();

  const returnValue = ref(initialValue)
  const loaded = ref(false)
  let storedValue;
  let unwatch;

  onMounted(() => {
    loaded.value = true

    if (storageSystem.value === 'localStorage') {
      storedValue = window.localStorage.getItem(key)
    }
  
    if (storageSystem.value === 'webViewMessenger') {
      storedValue = urlParams.get(key);
    }
  
    if (storageSystem.value === 'apiUserStorage') {
      storedValue = userStore.getAPIStorageItem(key)
    }
  
    if (storedValue) {
      returnValue.value = JSON.parse(storedValue)
    }
  
    unwatch = watch(
      returnValue,
      (val) => {
        if (storageSystem.value === 'localStorage') {
          window.localStorage.setItem(key, JSON.stringify(val))
        }
  
        if (storageSystem.value === 'webViewMessenger') {
          if ($PLATFORM === 'android') {
            const params = [key, val.toString()]
  
            alert(params.join(','))
          } else {
            const info = {
              type: key,
              value: val
            }
  
            window.webkit.messageHandlers.observe.postMessage(info)
          }
        }
  
        if (storageSystem.value === 'apiUserStorage') {
          userStore.updateAPIStorageItem(key, JSON.stringify(val))
        }
        
      },
      {
        deep: true
      }
    )
  })

  return [returnValue, loaded, unwatch];
}

export const updateStorageSystem = (system) => {
  storageSystem.value = system;
}
